import { render } from "./Ladders.vue?vue&type=template&id=31ae1309&scoped=true"
import script from "./Ladders.vue?vue&type=script&lang=js"
export * from "./Ladders.vue?vue&type=script&lang=js"

import "./Ladders.vue?vue&type=style&index=0&id=31ae1309&scoped=true&lang=scss"

import exportComponent from "/var/lib/buildkite-agent/builds/BKxAWS-i-0add72b42d7a2609c-1/assemble-sports/unisports-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ae1309"]])

export default __exports__